import { type CSSProperties, type FC, useCallback } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { CheckCircleIcon, Sizes } from "@snapchat/snap-design-system-icons";

import { type MyLensesLens } from "../../../gql-generated/types";

import { LensIcon, LensNameContainer, LensRowComponent, checkedIcon } from "./LensRow.styles";

interface LensRowProps {
    lens: MyLensesLens;
    onSelect?: (lens: MyLensesLens) => void;
    selected?: boolean;
    style: CSSProperties;
}

export const LensRow: FC<LensRowProps> = ({ lens, onSelect, selected = false, style }) => {
    const onClick = useCallback(() => {
        onSelect?.(lens);
    }, [onSelect, lens]);

    return (
        <LensRowComponent
            alignItems="center"
            onClick={onClick}
            selected={selected}
            style={style}
            data-testid={`lens-row__${lens.id}`}
        >
            <LensIcon iconUrl={lens.iconUrl} data-testid="lens-row__icon" />
            <LensNameContainer flexDirection="column" data-testid="lens-row__name">
                {lens.name}
            </LensNameContainer>
            {selected && (
                <CheckCircleIcon
                    className={checkedIcon}
                    size={Sizes.Small}
                    fill={Colors.Black.V50}
                    data-testid="lens-row__selected-icon"
                />
            )}
        </LensRowComponent>
    );
};
